import { render } from "./WizardPlates.vue?vue&type=template&id=75137442"
import script from "./WizardPlates.vue?vue&type=script&lang=js"
export * from "./WizardPlates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__